import PropTypes from 'prop-types';

export const ResidenceViewPropTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      data: PropTypes.oneOfType([
        // Video format - supports both videoId and serviceVideoId for compatibility
        PropTypes.shape({
          service: PropTypes.string,
          videoId: PropTypes.string,
          serviceVideoId: PropTypes.string,
        }),
        // Gallery format - supports both new API format (string) and legacy format (object)
        PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            uuid: PropTypes.string,
            image: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.shape({
                modal: PropTypes.string,
                fullScreen: PropTypes.string,
              }),
            ]),
            caption: PropTypes.string,
          }),
        ),
      ]),
    }),
  ),
};

export const ResidenceViewDefaultProps = {
  data: [],
};
